import * as React from 'react';
import styled from 'styled-components';
import Sidebar from 'components/Sidebar';
import Breadcrumbs from 'components/Breadcrumbs';
import {transition} from 'helpers/css';
import UserStore from 'stores/UserStore';
import {navigateTo} from "helpers/navigate-to";
import {useRoute} from "react-router5";
import {observer} from "mobx-react";

export interface PageContainerProps {
  children: React.ReactNode | React.ReactNodeArray;
}

export const Container = styled.div`
  position: relative;
  min-height: 100vh;
  display: flex;
  ${transition()};
`;

export const Content = styled.div`
  position: relative;
  width: 100%;
  display: grid;
  grid-template-rows: min-content 1fr;
`;

/**
 * This component wraps the page and sets global styles
 * @param {PageContainerProps} props
 * @constructor
 */
function PageContainer(
    props: PageContainerProps,
): React.ReactElement<PageContainerProps> {
  const {route} = useRoute();

  function renderBody() {
    const isAuthorized = Boolean(UserStore.state?.username);
    const isCoursePromo = route?.name === 'teachers.teacher.courses.course';

    const SidebarComponent = isAuthorized && <Sidebar /> || null;
    const BreadcrumbsComponent = isAuthorized && <Breadcrumbs /> || null;

    if (isAuthorized || isCoursePromo) {
      return (
        <React.Fragment>
          {SidebarComponent}
          <Content>
            {BreadcrumbsComponent}
            {props.children}
          </Content>
        </React.Fragment>
      )
    }
  }

  React.useEffect(() => {
    let timeout: any = null;

    const isAuthorized = Boolean(UserStore.state?.username);
    const isCoursePromo = route?.name === 'teachers.teacher.courses.course';

    if (!isAuthorized && !isCoursePromo) {
      timeout = setTimeout(() => navigateTo('login'), 0)
    }

    return () => timeout && clearTimeout(timeout)
  }, [])

  return (
    <Container>
      {renderBody()}
    </Container>
  );
}

export default observer(PageContainer)
